import { AyurvedaPregnancyCard, Button, HXIcon, Typography } from "@aph/ui-lib-humanx";
import NextLink from "next/link";
import { useRouter } from "next/navigation";
import IconPlus from "$/icons/icon-plus.svg";
import { ArticleAttributesInterface } from "@/components/ArticlePage/api/interface";
import Bookmark from "@/components/BookmarkAction";
import { FILTER_MAPPING, NON_ONBOARDED_STATUS, ONBOARDING_STATUS, TYPE_ARTICLE } from "@/helpers/constants";
import routes from "@/helpers/router";
import { assetClickedEvent } from "@/helpers/TSDEvents";
import SegmentInfoSelector from "@/redux/slice/auth/selectors/userSegmentInfo";
import { getPlainTexts, getResourceListingURL } from "@/helpers";
import { useAppSelector } from "@/redux/hooks";
import styles from "./ArticleTrimester.module.scss";

interface TrimesterArticlesProps {
  data: any;
  assetPosition: number;
  isPharma?: boolean;
  categorySlug?: string;
}

const TrimesterArticles = ({ data, assetPosition, isPharma = false, categorySlug }: TrimesterArticlesProps) => {
  const { Articles, Name, Slug, ShortDescription } = data;
  // TODO: Add 301 redirection of `${routes.resourcesListing("articles")}?pillar=${Slug}` to articleListingUrl
  const articleListingUrl = getResourceListingURL({ [FILTER_MAPPING.pillar]: [Slug] }, "articles");
  const router = useRouter();
  const SegmentInfoObject = useAppSelector(SegmentInfoSelector);

  return (
    <div className={styles.listRoot}>
      <div className={styles.list}>
        <div className={styles.upperSection}>
          <div>
            {Name && <h2 dangerouslySetInnerHTML={{ __html: Name }} className={styles.title} />}
            {ShortDescription && (
              <div className={styles.subTitle} dangerouslySetInnerHTML={{ __html: ShortDescription }} />
            )}
          </div>
          <div>
            <div className={styles.articleSection}>
              <Typography className={styles.text}>Articles</Typography>
              <Button color="tertiarybaby" className={styles.viewBtn}>
                <NextLink href={articleListingUrl} prefetch={false}>
                  <span className={styles.btn}>{`View More`}</span>
                </NextLink>
              </Button>
            </div>
            <>
              {!!Articles?.length && (
                <div className={styles.contentBx}>
                  {Articles.map((article: ArticleAttributesInterface, index: number) => {
                    const { id, AuthorName, ReadTime, Title, Image, Slug } = article;
                    const redirectUrl = isPharma ? `/blogs/article/${Slug}` : routes.article(Slug);

                    return (
                      <div key={id} className={styles.article}>
                        <AyurvedaPregnancyCard
                          ImageUrl={Image?.data?.attributes?.url}
                          title={Title}
                          authorName={AuthorName}
                          authorIcon={<IconPlus />}
                          labelText={ReadTime}
                          className={styles.ayurvedaPregnancyCard}
                          isImageCover
                          onCardClick={() => {
                            assetClickedEvent({
                              asset_name: getPlainTexts(Name),
                              asset_display_text: Title,
                              asset_position: assetPosition,
                              asset_element_position: index + 1,
                              momverse_stage: SegmentInfoObject?.type
                                ? (ONBOARDING_STATUS[SegmentInfoObject?.type] ?? "")
                                : NON_ONBOARDED_STATUS,
                            });
                            router.push(redirectUrl);
                          }}
                          redirectUrl={redirectUrl}
                          isBgStyle={false}
                          bookmark={<Bookmark type={TYPE_ARTICLE} itemId={article?.id} />}
                        />
                      </div>
                    );
                  })}
                </div>
              )}
            </>
          </div>
        </div>
        <div className={styles.bgStyle}>
          <HXIcon backgroundColor="#FDF3E7" iconPosition="topRight" className={`${styles.icon} ${styles.bIcon}`} />
          <HXIcon backgroundColor="#FDF3E7" iconPosition="right" className={`${styles.icon} ${styles.fIcon}`} />
        </div>
      </div>

      <NextLink href={isPharma ? `/blogs/${categorySlug}/${Slug}` : routes.pillar(Slug)} className={styles.link} prefetch={false}>
        <span className={styles.btn}>{`Explore ${Name}`}</span>
      </NextLink>
    </div>
  );
};

export default TrimesterArticles;
